import React, { useEffect, useState } from "react";

function LazyIframe(props) {
  const { width, height, frameBorder, allowtransparency, allow, className, src } = props;
  const [frame, setState] = useState({});

  useEffect(() => {
    setState({
      width,
      height,
      frameBorder,
      allowtransparency: allowtransparency === "true" ? true : false,
      allow,
      className: className ? className : "",
      src,
    });
  }, [width, height, frameBorder, allowtransparency, allow, className, src]);

  return (
    <iframe
      src={frame.src}
      loading="lazy"
      ref={frame.myRef}
      width={frame.width}
      height={frame.height}
      frameBorder={frame.frameBorder}
      allowtransparency={frame.allowtransparency}
      allow={frame.allow}
      className={frame.className}
    ></iframe>
  );
}

export default LazyIframe;
